<template>
    <div :class="['row', 'my-2', 'mt-3', 'text-center']">
        <div :class="['col-12']" v-if="errors.length">
            <ul :class="[$style.error__list]">
                <li :class="[$style.error__list__item]" v-for="(error, index) in errors" v-bind:key="index">{{ error }}</li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" module scoped>
   .error__list {
        margin-left:0;
        padding-left:0;
        .error__list__item {
            list-style: none;
            margin-bottom: 5px;
            color: #F37021;
            font-size:14px;
        }
    }
</style>

<script>
export default {
    props: {
        errors: {
            default: () => [],
            type : Array 
        }
    },
}
</script>